import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InputAdornment, Button, Box, TextField, Typography } from '@mui/material';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { Field, Form, Formik, ErrorMessage } from 'formik';
import { RESET_PASSWORD_REDIRECT_URL } from '../../../utils/redirect-const';
import { validatePassword, validateRequiredEmail } from '../../../utils/validators';

const LoginForm = ({ disabled, onSubmit }) => (
  <Formik
    initialValues={{
      username: '',
      password: '',
    }}
    validate={(values) => {
      const errors = {};
      const emailError = validateRequiredEmail(values.username);
      const passwordError = validatePassword(values.password);

      if (emailError) {
        errors.username = emailError;
      }
      if (passwordError) {
        errors.password = passwordError;
      }

      return errors;
    }}
    onSubmit={onSubmit}
    validateOnChange={true}
    validateOnBlur={true}
  >
    {({ isSubmitting, handleSubmit, dirty }) => (
      <Form onSubmit={handleSubmit}>
        <Box sx={{
          maxWidth: 400,
          mx: 'auto',
          p: 3,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Field
            name="username"
            as={TextField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlined />
                </InputAdornment>
              ),
            }}
            label="Email"
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <ErrorMessage name="username" component={Typography} color="error" />

          <Field
            name="password"
            as={TextField}
            type="password"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlined />
                </InputAdornment>
              ),
            }}
            label="Hasło"
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <ErrorMessage name="password" component={Typography} color="error" />

          <Box sx={{ mt: 2 }}>
            <Link to={RESET_PASSWORD_REDIRECT_URL} underline="none" variant="body2">
              Nie pamiętam hasła
            </Link>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              type="submit"
              disabled={isSubmitting || disabled}
            >
              Zaloguj
            </Button>
          </Box>
        </Box>
      </Form>
    )}
  </Formik>
);

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default LoginForm;